export default "__VITE_ASSET__DENvudlR__"